import React, { useState } from 'react';
import { SaveAsTemplateDialogProps } from './SaveAsTemplateDialogTypes';
import { useCreateProgramTemplateMutation } from '../../../ProgramTemplates';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

const SaveAsTemplateDialog = ({ open, onClose, blocks, onSuccess }: SaveAsTemplateDialogProps) => {
  const [templateName, setTemplateName] = useState('');
  const [templateDescription, setTemplateDescription] = useState('');
  const [createTemplate, { isLoading, error, isSuccess }] = useCreateProgramTemplateMutation();

  const handleSave = async () => {
    try {
      await createTemplate({
        name: templateName,
        description: templateDescription,
        blocks: blocks,
      }).unwrap();
      setTemplateName('');
      setTemplateDescription('');
      onClose();
      onSuccess?.();
    } catch {}
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Zapisz program jako szablon</DialogTitle>
      <DialogContent>
        <TextField
          label="Nazwa szablonu"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          fullWidth
          sx={{ mb: 2, mt: 1 }}
          autoFocus
          required
        />
        <TextField
          label="Opis (opcjonalnie)"
          value={templateDescription}
          onChange={(e) => setTemplateDescription(e.target.value)}
          fullWidth
          multiline
          minRows={2}
        />
        {error && (
          <Typography color="error" variant="body2" sx={{ mt: 2 }}>
            Wystąpił błąd przy zapisie szablonu.
          </Typography>
        )}
        {isSuccess && (
          <Typography color="success.main" variant="body2" sx={{ mt: 2 }}>
            Szablon zapisany pomyślnie!
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Anuluj
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!templateName || isLoading}>
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveAsTemplateDialog;
